import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RouterModule } from '@angular/router';
import { Api } from '../../core/services/api';
import { AuthService } from '../../core/services/auth';
import { WsService } from '../../core/services/ws-service';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-notification-badge',
    standalone: true,
    imports: [CommonModule, NzBadgeModule, NzIconModule, RouterModule],
    templateUrl: './notification-badge.html',
    styleUrl: './notification-badge.css',
})
export class NotificationBadge {
    notificationCount = signal<number>(0);
    private subscriptions: Subscription[] = [];
    limit = signal<number>(10);
    offset = signal<number>(0);
    constructor(private api: Api, private auth: AuthService, private ws: WsService) { }

    ngOnInit() {
        this.connectSocekt();
        this.loadWebSocketSubscriptions();
    }

    getUser() {
        return this.auth.currentUserSubject.value;
    }

    loadNotifications() {
        const user = this.getUser();
        const filter = this.buildFilter();
        if (user) {
            this.api.getNotifications(user.id, filter).subscribe({
                next: (response) => {
                    this.notificationCount.set(response.total);
                },
                error: (err) => {
                    console.error(err);
                }
            })
        }
    }

    buildFilter() {
        return {
            limit: this.limit(),
            offset: this.offset(),
        }
    }

    async connectSocekt() {
        await this.auth.getToken()?.then((token) => {
            this.ws.connect(token);
        })
    }

    loadWebSocketSubscriptions() {
        this.subscriptions.push(
            this.ws.on<any>('notification:new').subscribe(notification => {
                this.notificationCount.update((count) => count + 1);
            })
        )
        this.loadNotifications();
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
